import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './SideCardLink.module.scss';
import Icon from '../Icon';

const SideCardLink = ({ link = {}, title = '', text = '' }) => {
    return (
        <a href={link.href} className={styles['SideCardLink']}>
            <div className={styles['SideCardLink__Container']}>
                <h3 className={styles['SideCardLink__Title']}>{title}</h3>
                <p className={styles['SideCardLink__Text']}>{text}</p>
                <div className={classNames(
                    styles['SideCardLink__Bottom'],
                    {
                        [styles[
                            'SideCardLink__Bottom--WithText'
                        ]]: link && link.title,
                    }
                )}>
                    {link && link.title && (
                        <span className={styles['SideCardLink__LinkText']}>{link.title}</span>
                    )}
                    <Icon type="arrow" size="large" />
                </div>
            </div>
        </a>
    );
};

SideCardLink.propTypes = {
    link: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
};

export default SideCardLink;
